import * as PropTypes                  from 'prop-types';
import {
    compose,
    withProps,
    withState,
    branch,
    renderNothing,
    getContext
}                                      from 'recompose';
import { connect }                     from 'react-redux';
import { withRouter }                  from 'react-router';
import MessagesInput                   from './MessagesInput';
import {
    MessagesInputType,
    MessagesInputContainerProps
}                                      from './MessagesInputTypes';
import { selectCustomField }           from '../CustomFields/CustomFieldsActions';
import { ViewContextTypes }            from '../MessageTemplatesList/MessageTemplatesListTypes';

const CHARACTER_LIMIT = 160;
const TEMPLATE_ITEMS_PER_PAGE = 1;

const isLoading = ({ loading }) => loading;

const sendInputMessage = (conversationId, value, sendMessage, setValue) => {
    if (value.length <= CHARACTER_LIMIT && value.trim().length > 0) {
        sendMessage(conversationId, value);
        setValue('');
    }
};

const mapDispatchers = (dispatch) => ({
    resetSelectedCustomField() {
        dispatch(selectCustomField(null, null));
    }
});

// TODO: proper reducer / actions after adding state properties?
const MessagesInputContainer = compose(
    connect(null, mapDispatchers),
    withRouter,
    withState('value', 'setValue', ''),
    withState('inputView', 'setInputView', ViewContextTypes.DEFAULT),
    withState('templatesInitialized', 'initializeTemplates', false),
    getContext({
        isOnCallList: PropTypes.bool.isRequired,
    }),
    withProps(({ setValue, sendMessage, conversationId, value, setInputView, resetSelectedCustomField }: MessagesInputContainerProps) => ({
        characterLimit: CHARACTER_LIMIT,
        itemsPerPage: TEMPLATE_ITEMS_PER_PAGE,
        handleChange: (event: React.SyntheticEvent<MessagesInputType>) => {
            setValue(event.currentTarget.value);
        },
        handleSendMessage: () => sendInputMessage(conversationId, value, sendMessage, setValue),
        // Send on enter key press on desktop
        handleKeyDown: (event) => {
            const condition = (
                (event as KeyboardEvent).key === 'Enter' &&
                !(event as any).nativeEvent.shiftKey &&
                window.innerWidth > 640
            );

            if (condition) {
                sendInputMessage(conversationId, value, sendMessage, setValue);
                event.preventDefault();
                event.stopPropagation();
            }
        },
        handleChangeInputView({ target }) {
            resetSelectedCustomField();
            setInputView(target.value);
        },
    })),
    branch(isLoading, renderNothing)
);

export default MessagesInputContainer(MessagesInput) as React.ComponentClass<MessagesInputContainerProps>;



// WEBPACK FOOTER //
// ./src/sections/MessagesInput/index.ts